import React from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

interface ItemsPerPageProps {
  currentItemsPerPage: number;
  onItemsPerPageChange: (itemsPerPage: number) => void;
  isLoading?: boolean;
  showAll?: boolean;
}

const ITEMS_PER_PAGE_OPTIONS = [
  { value: 9, label: '9' },
  { value: 18, label: '18' },
  { value: 27, label: '27' },
  { value: 36, label: '36' },
  { value: -1, label: 'Show All' }
];

const ItemsPerPage: React.FC<ItemsPerPageProps> = ({
                                                     currentItemsPerPage,
                                                     onItemsPerPageChange,
                                                     isLoading = false,
                                                     showAll = false
                                                   }) => {
  const handleChange = (event: SelectChangeEvent<number>) => {
    onItemsPerPageChange(Number(event.target.value));
  };

  const selectedValue = showAll || currentItemsPerPage === -1 ? -1 : currentItemsPerPage;

  return (
    <FormControl size="small" sx={{ minWidth: 160 }}>
      <Select
        value={selectedValue}
        onChange={handleChange}
        disabled={isLoading}
        displayEmpty
        renderValue={(val) => {
          if (val === -1 || showAll) {
            return 'Items per page (Show All)';
          }
          return `Items per page (${val})`;
        }}
        sx={{
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '& .MuiSelect-select': {
            py: 1,
          }
        }}
      >
        {ITEMS_PER_PAGE_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <ListItemIcon sx={{ minWidth: 32 }}>
              {selectedValue === option.value && (
                <CheckIcon fontSize="small" color="primary" />
              )}
            </ListItemIcon>
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ItemsPerPage;